import map from "lodash/fp/map";
import assign from "lodash/fp/assign";
import flow from "lodash/fp/flow";
import constants from "../../core/constants";
import { mapGetIds } from "../../core/transforms";

import moment from "moment";

class PromotionsPageTransform {
  constructor(Events) {
    "ngInject";
    this.onSelectCityEvent = Events.getSelectCityEvent();
    Events.on(this.onSelectCityEvent, this.getCity.bind(this));

    // NOTE: name is used for (user roles)
    this.item = {
      title: "Promotion",
      state: "promotion",
      name: "promotion",
    };

    this.fields = [
      { title: "Name", name: "name", isSortable: true },
      { title: "Code", name: "code", isSortable: true },
      { title: "Start Date", name: "start_date", isSortable: true },
      { title: "End Date", name: "end_date", isSortable: true },
    ];

    this.filters = [
      { name: "city", title: "City", icon: "location_city", resource: "City" },
      {
        name: "search",
        title: "Search",
        icon: "search",
        isSearch: true,
        resource: "Promotion",
        state: "promotion",
      },
      {
        name: "date",
        title: "Select date",
        icon: "date_range",
        isDate: true,
        hasRange: false,
      },
      {
        name: "segment",
        title: "Segment",
        icon: "turned_in",
        list: "promoSegments",
      },
    ];

    this.addOptions = {
      title: "Add New Promotion",
      icon: "add",
      fields: [
        {
          name: "name",
          title: "Name",
          type: "text",
          isText: true,
          isRequired: true,
        },
        {
          name: "description",
          title: "Description",
          type: "text",
          isText: true,
          isRequired: false,
        },
        {
          name: "segment",
          title: "Segment",
          list: "promoSegments",
          isRequired: true,
        },
        {
          name: "code",
          title: "Code",
          type: "text",
          isText: true,
          isRequired: true,
        },
        {
          name: "start_date",
          title: "Start Date",
          dateTime: true,
          isRequired: true,
        },
        {
          name: "end_date",
          title: "End Date",
          dateTime: true,
          isRequired: false,
        },
        {
          name: "ride_categories",
          title: "Categories",
          list: "rideCategoryList",
          multiple: true,
          isRequired: true,
        },
        {
          name: "display_to_users",
          title: "Display To User",
          isCheckBox: true,
          isRequired: true,
          default: true,
        },
        {
          name: "first_ride",
          title: "First Ride",
          isCheckBox: true,
          isRequired: false,
        },
        {
          name: "personalized",
          title: "Personalized",
          isCheckBox: true,
          isRequired: false,
        },
        {
          name: "renewal",
          title: "Renewal",
          icon: "autorenew",
          list: "initialRenewalValues",
        },
        {
          name: "value",
          isPromotionValue: true,
          isRequired: true,
          showHint: true,
          hint:
            "You should select at least one city before entering promotion value.",
        },
        {
          name: "cities",
          title: "Cities",
          isResourceList: true,
          resource: "City",
          items: [],
          formatter: mapGetIds,
          isRequired: true,
          onChange: this.onSelectCityEvent,
        },
        {
          name: "routes",
          title: "Routes",
          isResourceList: true,
          resource: "Route",
          items: [],
          formatter: mapGetIds,
          isRequired: false,
        },
        {
          name: "rides",
          title: "Rides",
          isResourceList: true,
          resource: "Ride",
          items: [],
          formatter: mapGetIds,
          isRequired: false,
        },
        {
          name: "pick_ups",
          title: "Pickup",
          isResourceList: true,
          resource: "Station",
          items: [],
          formatter: mapGetIds,
          isRequired: false,
        },
        {
          name: "drop_offs",
          title: "Dropoff",
          isResourceList: true,
          resource: "Station",
          items: [],
          formatter: mapGetIds,
          isRequired: false,
        },
        {
          name: "stations",
          title: "Stations",
          isResourceList: true,
          resource: "Station",
          items: [],
          formatter: mapGetIds,
          isRequired: false,
        },
        {
          name: "users",
          title: "Customers",
          isResourceList: true,
          resource: "User",
          items: [],
          formatter: mapGetIds,
          isRequired: false,
        },
      ],
    };
  }

  justify(data) {
    const getSource = (item) => assign({ _id: item._id }, item._source);
    const formatDate = (item) => {
      item.start_date = moment(item.start_date).format(
        constants.dateTimeFormat
      );
      item.end_date = moment(item.end_date).format(constants.dateTimeFormat);

      return item;
    };
    return map(flow([getSource, formatDate]))(data);
  }

  getCity() {
    const findAddOptionsFieldName = (fields, field) => {
      return fields.find((f) => f.name === field);
    };
    const fields = this.addOptions.fields;
    const promotionValueFiled = findAddOptionsFieldName(fields, "value");
    const promotionCitiesFiled = findAddOptionsFieldName(fields, "cities");
    if (promotionCitiesFiled.items.length !== 0) {
      promotionValueFiled.showHint = false;
      promotionValueFiled.city = promotionCitiesFiled.items[0].name;
    } else {
      promotionValueFiled.showHint = true;
    }
  }
}

export default PromotionsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/promotions/promotions.transforms.js